<form [formGroup]="form" (ngSubmit)="acceptAndDownload()">
  <nb-card class="form avv-dialog">
    <nb-card-header>
      <h4>{{ "pages.organisation.avv.dialogTitle" | translate }}</h4>
    </nb-card-header>

    <nb-card-body>
      <div class="avv-meta" *ngIf="avv">
        <span>{{ "pages.organisation.avv.version" | translate }} {{ avv.version }}</span>
        <span *ngIf="avv.accepted && avv.accepted_at">
          {{ "pages.organisation.avv.acceptedAt" | translate }}
          {{ avv.accepted_at | date : "short" : "CET" }}
        </span>
      </div>

      <div class="form-group">
        <label class="label">{{ "pages.organisation.avv.customerName" | translate }}</label>
        <input
          nbInput
          fullWidth
          formControlName="customer_name"
          [status]="showInputError('customer_name') ? 'danger' : 'basic'"
        />
      </div>

      <div class="address-grid">
        <div class="form-group address-grid__street">
          <label class="label">{{ "pages.organisation.avv.customerStreet" | translate }}</label>
          <input
            nbInput
            fullWidth
            formControlName="customer_street"
            [status]="showInputError('customer_street') ? 'danger' : 'basic'"
          />
        </div>

        <div class="form-group">
          <label class="label">{{ "pages.organisation.avv.customerNumber" | translate }}</label>
          <input
            nbInput
            fullWidth
            formControlName="customer_number"
            [status]="showInputError('customer_number') ? 'danger' : 'basic'"
          />
        </div>

        <div class="form-group">
          <label class="label">{{ "pages.organisation.avv.customerZip" | translate }}</label>
          <input
            nbInput
            fullWidth
            formControlName="customer_zip"
            [status]="showInputError('customer_zip') ? 'danger' : 'basic'"
          />
        </div>

        <div class="form-group">
          <label class="label">{{ "pages.organisation.avv.customerCity" | translate }}</label>
          <input
            nbInput
            fullWidth
            formControlName="customer_city"
            [status]="showInputError('customer_city') ? 'danger' : 'basic'"
          />
        </div>

        <div class="form-group address-grid__country">
          <label class="label">{{ "pages.organisation.avv.customerCountry" | translate }}</label>
          <input
            nbInput
            fullWidth
            formControlName="customer_country"
          />
        </div>
      </div>

      <div class="avv-preview" *ngIf="renderedPreviewHtml">
        <div class="avv-preview__document" [innerHTML]="renderedPreviewHtml"></div>
      </div>

      <nb-checkbox formControlName="accepted">
        {{ "pages.organisation.avv.acceptCheckbox" | translate }}
      </nb-checkbox>
    </nb-card-body>

    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="dialogRef.close()"
      >
        {{ "buttons.cancel" | translate }}
      </button>
      <button
        type="button"
        nbButton
        status="primary"
        outline
        [disabled]="!avv?.accepted || downloading || saving"
        (click)="download()"
      >
        <nb-icon [icon]="downloading ? 'loader-outline' : 'download-outline'" [class.spin]="downloading"></nb-icon>
        {{ "pages.organisation.avv.download" | translate }}
      </button>
      <button type="submit" nbButton status="primary" [disabled]="saving || downloading">
        <nb-icon [icon]="saving ? 'loader-outline' : 'checkmark-circle-2-outline'" [class.spin]="saving"></nb-icon>
        {{ "pages.organisation.avv.acceptAndDownload" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
